import SupplierService from '@/services/SupplierService';
import LiveChatService from '@/services/LiveChatService';

export default {
  async getToken () {
    return LiveChatService.generateVerificationToken();
  },
  redirectUrlGenerator ({ token }) {
    return LiveChatService.getRedirectUrl(token);
  },
  getGtmEvent () {
    return {
      event: 'GAEvent',
      eventCategory: 'AccountSSOPage',
      action: 'Live Chat SSO',
      eventLabel: SupplierService.getSupplierId(),
    };
  },
};
